import styled from 'styled-components';

import { Modal } from '@/ui/Modal';
import { CustomEditorV2Readonly } from '@/component/customEditorV2';
import { toRichTextEditorValue } from '@/features/journey/admin/utils/richTextValue';

const Title = styled.h2`
  ${(p) => p.theme.typography.title3}
  margin: 24px 0 16px 0;
`;

// The readonly editor ships page-level paddings and a 776px max-width meant for the
// course viewer; reset them so the content flows like regular modal text.
const READONLY_EDITOR_STYLE = { fontSize: 14, padding: 0, maxWidth: '100%' } as const;

type JourneyViewShowDescriptionModalProps = {
  open: boolean;
  onClose: () => void;

  description?: string;
  businessGoal?: string;
  spaceId: number;
};

export const JourneyViewShowDescriptionModal = ({
  open,
  onClose,
  description,
  businessGoal,
  spaceId,
}: JourneyViewShowDescriptionModalProps): JSX.Element | null => {
  return (
    <Modal open={open} onClose={onClose} size="tablet">
      <Modal.Title>{!!description ? 'Journey description' : 'Journey goals'}</Modal.Title>
      <Modal.Contents>
        {description && (
          <CustomEditorV2Readonly
            value={toRichTextEditorValue(description)}
            style={READONLY_EDITOR_STYLE}
            $fullSize
            minimized
            spaceId={spaceId}
          />
        )}
        {description && businessGoal && <Title>Journey goals</Title>}
        {businessGoal && (
          <CustomEditorV2Readonly
            value={toRichTextEditorValue(businessGoal)}
            style={READONLY_EDITOR_STYLE}
            $fullSize
            minimized
            spaceId={spaceId}
          />
        )}
      </Modal.Contents>

      <Modal.Actions>{<Modal.Action action={onClose}>Close</Modal.Action>}</Modal.Actions>
    </Modal>
  );
};
